<template lang="pug">
v-dialog(v-model='show', max-width='500')
      v-card
        v-card-title Asociar Proveedor
        v-card-text
          v-form(ref='form', v-model='valid')
            v-select(v-model='selectedSupplier', :items='suppliers', multiple='', item-text='businessName', item-value='_id', label='Proveedor', :rules="[v => !!v || 'Selecciona un proveedor']", required='')
        v-card-actions
          v-spacer
          v-btn(text='', @click='close') Cancelar
          v-btn(color='primary', :disabled='!valid', @click='save') Guardar
</template>
<script>
export default {
  name: 'ItemSupplierDialog',
  props: {
    value: Boolean,
    item: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    valid: false,
    selectedSupplier: null
  }),

  computed: {
    show: {
      get() { return this.value },
      set(value) { this.$emit('input', value) }
    },
    suppliers() {
      return this.$store.state.suppliers.list.filter(s => s.active)
    }
  },

  methods: {
    close() {
      this.show = false
      this.$refs.form.reset()
    },

    async save() {
      if (!this.$refs.form.validate()) return

      try {
        await this.$http.post(`/items/${this.item._id}/suppliers`, {
          supplierId: this.selectedSupplier
        })
        this.$toast.success('Proveedor asociado')
        this.close()
        this.$emit('saved')
      } catch (error) {
        this.$toast.error('Error al asociar proveedor')
      }
    }
  },
  async created() {
    this.loading = true
    try {
      await this.$store.dispatch('suppliers/fetch')
    } catch (error) {
      this.$toast.error('Error al cargar los proveedores')
    } finally {
      this.loading = false
    }
  }
}
</script>
